module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/errors/404/not-found-primary.png?1c66df0b8515567e765b58321a28ba24";